import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M 10.5 7 H 7.5 V 8 H 9.5 V 14 H 7.5 V 15 H 12.5 V 14 H 10.5 Z M 9.5 4 C 8.948 4 8.5 4.448 8.5 5 S 8.948 6 9.5 6 S 10.5 5.552 10.5 5 S 10.052 4 9.5 4 Z M 10 0 C 4.753 0 0.5 4.253 0.5 9.5 S 4.753 19 10 19 S 19.5 14.747 19.5 9.5 S 15.247 0 10 0 Z M 10 18 C 5.313 18 1.5 14.187 1.5 9.5 S 5.313 1 10 1 C 14.687 1 18.5 4.813 18.5 9.5 S 14.687 18 10 18 Z',
  ],
  height: 20,
  width: 20,
});
